import { Component } from '@angular/core';

import { Observable } from 'rxjs';
import { ChangeFailRateCalculatorService } from '../../services/change-fail-rate-calculator.service';
import { TeamMetricsService } from '../../services/team-metrics.service';
import { ChangeFailRateResult } from '../../models/team-metrics';
import { MetricCardComponent } from '../metric-card/metric-card.component';
import { BaseMetricComponent } from './base-metric.component';

@Component({
  selector: 'app-change-fail-rate-metric',
  standalone: true,
  imports: [MetricCardComponent],
  template: `
    <app-metric-card
      title="Change Fail Rate"
      icon="running_with_errors"
      [metricData]="metricDataToDisplay"
      metricType="changeFailRate"
      [isLoading]="isLoading || (isOtherMetricLoading ?? false)"
      tooltipText="Percentage of releases that resulted in failures">
    </app-metric-card>
  `
})
/**
 * Component to display the Change Fail Rate metric.
 * It extends BaseMetricComponent to leverage common metric functionalities.
 */
export class ChangeFailRateMetricComponent extends BaseMetricComponent<ChangeFailRateResult> {
  
  /**
   * Constructs the ChangeFailRateMetricComponent.
   * @param cfrCalculatorService Service to calculate change fail rate.
   * @param teamMetricsService Service for shared team metrics functionalities.
   */
  constructor(
    private readonly cfrCalculatorService: ChangeFailRateCalculatorService,
    teamMetricsService: TeamMetricsService
    ) {
    super(teamMetricsService);
  }

  /**
   * Fetches the change fail rate metric data.
   * This method is called by the base component to retrieve metric data.
   * @param team The team name for which to calculate the metric.
   * @param isoStartDate The start date of the period in ISO format.
   * @param isoEndDate The end date of the period in ISO format.
   * @param org The ADO organization name.
   * @param project The ADO project name. 
   * @returns An Observable emitting the ChangeFailRateResult or null.
   */
  protected callFetchMetric(
    team: string, 
    isoStartDate: string, 
    isoEndDate: string,
    org: string,
    project: string
  ): Observable<ChangeFailRateResult | null> {
    return this.cfrCalculatorService.calculate(team, isoStartDate, isoEndDate, org, project, true);
  }
}
